import {
  BestTicketBlockDetails,
  PlanPackageComponentDetails,
  SectionDetails,
} from "features/types";
export interface FiltersInterface {
  showAccessible: boolean;
  showPremium: boolean;
  sortBy: SeatSelectionState["sortBy"];
}

export interface SeatSelectionState {
  allBlocks: SectionDetails[] | BestTicketBlockDetails[];
  mapKey: number;
  originalPartySize: number;
  selection: number;
  step: number;
  expansionPanel: boolean;
  selectedPlanType: PlanPackageComponentDetails["type"] | "";
  sortBy:
    | typeof PRICE_HIGH_TO_LOW
    | typeof PRICE_LOW_TO_HIGH
    | typeof QUALITY_HIGH_TO_LOW
    | typeof QUALITY_LOW_TO_HIGH;
  venueMapKey: number; // used to reset venue map
  filters: FiltersInterface;
}

export const PRICE_HIGH_TO_LOW = "Price (High to Low)";
export const PRICE_LOW_TO_HIGH = "Price (Low to High)";
export const QUALITY_HIGH_TO_LOW = "Quality (High to Low)";
export const QUALITY_LOW_TO_HIGH = "Quality (Low to High)";

export const sortByItems: SeatSelectionState["sortBy"][] = [
  PRICE_HIGH_TO_LOW,
  PRICE_LOW_TO_HIGH,
  QUALITY_HIGH_TO_LOW,
  QUALITY_LOW_TO_HIGH,
];
